import { updateConsultRequestFields, updateQualificationResponses } from '../../services/customFieldService';
import { t } from '../../utils/i18n';
import {
    appUrl,
    form,
    leadTextId,
    listDataQuestion,
    listNamePageQuestion,
    nameScreenDynamic,
    progressQuestion,
    setListDataQuestion,
    setListNamePageQuestion,
    setNameScreenDynamic,
    setProgressQuestion,
    questionnaireFields,
    questionnaireFormId,
    clearQuestionnaireContext,
} from '../../utils/variables';
import { toastError } from '../../views/components/error';
import { loadCustomFields } from '../actions/consultActions';
import { checkboxQuestionListener } from './checkboxQuestionListener';
import { dateQuestionListener } from './dateQuestionListener';
import { heightQuestionListener } from './heightQuestionListener';
import { customFeildGoBackAnimationHandler, navigate, setSessionEndStepSentForLeadId, setIsDisqualified } from './movePages';
import { numberQuestionListener } from './numberQuestionListener';
import { selectQuestionListener } from './selectQuestionListener';
import { textAreaQuestonListener } from './textareaQuestionListener';
import { navigateToNextPageWithClearFields } from './navigationHelper';
import { evaluateDisqualifier, shouldDisqualifyNow } from '../../utils/disqualifierEvaluator';
import { SCREEN } from '../../utils/constants';
import { clearCustomFields } from '../actions/consultActions';
import { updateLeadStep } from '../../services/leadServices';
import { leadInfo } from '../../utils/variables';

export function textQuestionListener() {
    // check has data
    if (
        listNamePageQuestion.find((name) => name === nameScreenDynamic) &&
        listDataQuestion[nameScreenDynamic.split('--')[1]]
    ) {
        const value = document.querySelector(
            `${nameScreenDynamic} .textQuestion--input`
        );
        if (value) {
            value.value = listDataQuestion[nameScreenDynamic.split('--')[1]];
        }
        setTimeout(() => {
            const textNameInput = document.querySelector(
                `${nameScreenDynamic} #textQuestion`
            );
            if (textNameInput !== document.activeElement) {
                textNameInput.focus();
            }
        }, 500);
        document
            .querySelector(`${nameScreenDynamic} .textQuestionContinue__btn`)
            ?.classList.remove('disabled');
        document
            .querySelector(`${nameScreenDynamic} .textQuestion__valid`)
            ?.classList.remove('hidden');
        document
            .querySelector(
                `${nameScreenDynamic} .textQuestionContinue__btn .loading__wrapper`
            )
            ?.classList.add('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<i class="ri-arrow-right-line"></i>`
            );
        }
        document
            .querySelector(`${nameScreenDynamic} .textQuestion__invalid`)
            ?.classList.add('hidden');
        return;
    }

    validateName();

    const isValidIcon = document.querySelector(
        `${nameScreenDynamic} .textQuestion__valid`
    );

    isValidIcon?.addEventListener('click', function () {
        document
            .querySelector(
                `${nameScreenDynamic} .textQuestionContinue__btn`
            )
            ?.click();
    });

    /* On click enter */
    const screenTextQuestion = document.querySelector(
        `${nameScreenDynamic} .screen--text`
    );

    if (screenTextQuestion) {
        screenTextQuestion.addEventListener('keydown', (event) => {
            if (
                event.key === 'Enter' &&
                !document
                    .querySelector(
                        `${nameScreenDynamic} .textQuestionContinue__btn`
                    )
                    .classList.contains('disabled')
            ) {
                document
                    .querySelector(
                        `${nameScreenDynamic} .textQuestionContinue__btn`
                    )
                    .click();
            }
        });
    }

    /* On click Back button */
    document
        .querySelector(`${nameScreenDynamic} .textQuestionBack__btn`)
        ?.addEventListener('click', () => {
            const idx = listNamePageQuestion.findIndex(
                (l) => l === nameScreenDynamic
            );
            if (idx > 0) {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion - 1,
                    progress: (((progressQuestion.currentQuestion - 1) / progressQuestion.total) * 100)
                });
                setNameScreenDynamic(listNamePageQuestion[idx - 1]);

                if (
                    nameScreenDynamic.includes('text') &&
                    !nameScreenDynamic.includes('textarea')
                ) {
                    textQuestionListener();
                } else if (nameScreenDynamic.includes('checkbox')) {
                    checkboxQuestionListener();
                } else if (nameScreenDynamic.includes('select')) {
                    selectQuestionListener();
                } else if (nameScreenDynamic.includes('date')) {
                    dateQuestionListener();
                } else if (nameScreenDynamic.includes('textarea')) {
                    textAreaQuestonListener();
                } else if (nameScreenDynamic.includes('number')) {
                    numberQuestionListener();
                } else if (nameScreenDynamic.includes('height')) {
                    heightQuestionListener();
                }
            } else {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
            }
        });

    /* on click Continue */
    document
        .querySelector(`${nameScreenDynamic} .textQuestionContinue__btn`)
        ?.addEventListener('click', async () => {
            if (
                !listNamePageQuestion.find((list) => list === nameScreenDynamic)
            ) {
                listNamePageQuestion.push(nameScreenDynamic);
            }
            setListNamePageQuestion(listNamePageQuestion);
            document
                .querySelector(
                    `${nameScreenDynamic} .textQuestionContinue__btn`
                )
                .classList.add('disabled');
            document
                .querySelector(
                    `${nameScreenDynamic} .textQuestionContinue__btn .loading__wrapper`
                )
                ?.classList.remove('hidden');
            const loaderIcon = document.querySelector(
                `${nameScreenDynamic} .loader__icon`
            );
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML(
                    'beforeend',
                    `<img src="${appUrl}/assets/icons/rolling.png" />`
                );
            }
            const item = nameScreenDynamic.split('--')[1];
            const textVal = document.querySelector(
                `${nameScreenDynamic} .textQuestion--input`
            ).value;
            const answersWithCurrent = { ...listDataQuestion, [item]: textVal };
            listDataQuestion[item] = textVal;
            setListDataQuestion(listDataQuestion);
            const fields = questionnaireFields?.length
                ? questionnaireFields
                : form?.form?.custom_fields ?? [];
            const currentField = fields.find((f) => f && f.id == item);
            const minDisqualifiers = form?.appointment_channel?.min_disqualifier_matches ?? form?.consult_min_disqualifier_matches ?? 1;
            if (currentField && evaluateDisqualifier(currentField, textVal) && shouldDisqualifyNow(fields, answersWithCurrent, minDisqualifiers)) {
                try {
                    const fieldLabels = {};
                    const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                    sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || t('custom_field')); });
                    const formId = questionnaireFormId ?? form?.form?.id;
                    if (typeof formId === 'string' && formId.startsWith('ac-')) {
                        const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                        await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                    } else {
                        await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                    }
                } catch (_) { /* save best-effort */ }
                if (leadInfo?.id) {
                    await updateLeadStep(leadInfo.id, 'disqualified', 'true');
                    setSessionEndStepSentForLeadId(leadInfo.id);
                }
                document.querySelector(`${nameScreenDynamic} .textQuestionContinue__btn`)?.classList.remove('disabled');
                document.querySelector(`${nameScreenDynamic} .textQuestionContinue__btn .loading__wrapper`)?.classList.add('hidden');
                const loaderIcon = document.querySelector(`${nameScreenDynamic} .loader__icon`);
                if (loaderIcon) { loaderIcon.innerHTML = ''; loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>'); }
                clearCustomFields();
                clearQuestionnaireContext();
                setIsDisqualified(true);
                navigate(SCREEN.THE_END);
                return;
            }
            const formId = questionnaireFormId ?? form?.form?.id;
            let idx = fields.findIndex(
                (custom) => custom && custom.id == nameScreenDynamic.split('--')[1]
            );
            if (idx == fields.length - 1) {
                try {
                    const fieldLabels = {};
                    const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                    sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || t('custom_field')); });
                    if (typeof formId === 'string' && formId.startsWith('ac-')) {
                        const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                        await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                    } else {
                        await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                    }
                    document
                        .querySelector(
                            `${nameScreenDynamic} .textQuestion__container .textQuestionContinue__btn`
                        )
                        ?.classList.remove('disabled');
                    document
                        .querySelector(
                            `${nameScreenDynamic} .textQuestionContinue__btn .loading__wrapper`
                        )
                        ?.classList.add('hidden');
                    const value = document.querySelector(
                        `${nameScreenDynamic} .textQuestion--input`
                    );
                    if (value) {
                        value.value = '';
                    }
                    const loaderIcon = document.querySelector(
                        `${nameScreenDynamic} .loader__icon`
                    );
                    if (loaderIcon) {
                        loaderIcon.innerHTML = '';
                        loaderIcon.insertAdjacentHTML(
                            'beforeend',
                            `<i class="ri-arrow-right-line"></i>`
                        );
                    }
                    document
                        .querySelector(
                            `${nameScreenDynamic} .textQuestion__invalid`
                        )
                        ?.classList.add('hidden');
                    document
                        .querySelector(
                            `${nameScreenDynamic} .textQuestion__valid`
                        )
                        ?.classList.add('hidden');

                    clearQuestionnaireContext();
                    navigateToNextPageWithClearFields();
                } catch (error) {
                    toastError(error.response?.data?.message);
                }
            } else {
                // handle
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion + 1,
                    progress: (((progressQuestion.currentQuestion + 1) / progressQuestion.total) * 100)
                });
                loadCustomFields(fields[idx + 1]);
            }
        });
}

function validateName() {
    const name = document.querySelector(`${nameScreenDynamic} #textQuestion`);
    const nameWrap = document.querySelector(
        `${nameScreenDynamic} .textQuestion`
    );
    const invalidIcon = document.querySelector(
        `${nameScreenDynamic} .textQuestion__invalid`
    );
    const validIcon = document.querySelector(
        `${nameScreenDynamic} .textQuestion__valid`
    );

    if (name) {
        name.oninput = (e) => {
            if (!e.target.value) {
                nameWrap.classList.remove('valid');
                nameWrap.classList.add('invalid');
                invalidIcon.classList.remove('hidden');
                document
                    .querySelector(
                        `${nameScreenDynamic} .textQuestionContinue__btn`
                    )
                    .classList.add('disabled');
            } else {
                nameWrap.classList.add('valid');
                invalidIcon.classList.add('hidden');
                validIcon.classList.remove('hidden');
                name.classList.remove('invalid');
                document
                    .querySelector(
                        `${nameScreenDynamic} .textQuestionContinue__btn`
                    )
                    .classList.remove('disabled');
            }
        };
    }
}
